const types = ['koperta', 'paczka', 'paleta'];

export const type = {
    type: String,
    validator(value) {
        return types.indexOf(value) !== -1;
    }
};